export default {
    intro: 'Hãy xem nghĩa và chọn từ phù hợp!',
    th: { order: 'Số thứ tự', meaning: 'Câu hỏi', answer: 'Đáp án đúng', wrong: 'Đáp án sai', wrongChoices: 'Đáp án sai', correctRate: 'Độ chính xác' },
    manySelectedWrongAnswer: 'Đáp án sai được chọn nhiều nhất',
};
